import DotBtnItem from 'Components/Atoms/DotBtnItem/DotBtnItem';
import { Arrow } from 'Components/Atoms/ExpandableItems/Arrow';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { copyDataset, createDataset, deleteDataset, editDataset } from 'Store/FieldManagement/Actions';
import EditButtons from 'Components/Atoms/EditButtons/EditButtons';
import Field from 'Pages/Dashboard/Settings/FieldsManagement/Fields/FieldTypes/Field';
import { getDatasetValue } from 'Services/helpers';
import { FieldType } from 'Store/FieldManagement/PropTypes';
import { getAllDatasets } from 'Store/FieldManagement/Selectors';
import { API_URL } from 'Store/Shared/Middleware/API/Constants';
import Modal from '../Modals/Modal/Modal';
import ModalHeader from '../Modals/ModalHeader/ModalHeader';
import Title from 'Components/Atoms/Title/Title';
import FormSection from '../Form/FormSection/FormSection';
import FormGroup from '../Form/FormGroup/FormGroup';
import Container from 'Components/Atoms/Container/Container';
import ModalFooter from '../Modals/ModalFooter/ModalFooter';
import ButtonGroup from '../ButtonGroup/ButtonGroup';
import Button from 'Components/Atoms/Button/Button';

const DatasetNodeContainer = ({ id, node, nestedKey, isLastInArray, parentId, css, datasets, ...props}: any) => {
    nestedKey = nestedKey + 1;
    const nodeKeys = node.children && Object.keys(node.children);

    const [isEdit, setEdit] = useState(false);
    const [isChildOpen, setChildOpen] = useState(false);
    const [isSibling, setSiblingOpen] = useState(false);
    const [copyModal, setCopyModal] = useState(false);
    const [isExpanded, setExpanded] = useState(false);

    const [addChild, setAddChild] = useState('');
    const [addSibling, setAddSibling] = useState('');
    const [copyNode, setCopyNode] = useState('');
    const [editValue, setEditValue] = useState(node.title);

    const [isDeleteDisabled, setDeleteDisabled] = useState(true);
    const [deleteDescription, setDeleteDescription] = useState('');
    const [usedValues, setUsedValues] = useState([]);

    const editHandler = () => {
        if (!editValue) return;
        setEdit(false);
        props.editDataset(editValue, node.value);
    }

    const createChildHandler = () => {
        if (!addChild) return;
        setChildOpen(false);
        props.createDataset(addChild, node.value);
    }

    const createSiblingHandler = () => {
        if (!addSibling) return;
        setSiblingOpen(false);
        props.createDataset(addSibling, parentId);
    }

    const copyHandler = () => {
        if (!copyNode) return;
        setCopyModal(false);
        props.copyDataset(copyNode, parentId, getDatasetValue(datasets, node.value));
    }

    const deleteHandler = () => {
        props.deleteDataset(node.value);
    }

    const onDeleteOpen = (a) => {
        if (!a) return;
        const token: any = localStorage.getItem(window.btoa('accessToken'));
        const accessToken = window.atob(token);
        fetch(`${API_URL}/api/field-management/datasets/usage`, {
            method: 'PATCH',
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
            body: JSON.stringify({ 'dataset': getDatasetValue(datasets, node.value) })
        }).then(async (item: any) => {
            const response = await item.json();
            const isUsed = response['data'].length > 0;
            setDeleteDisabled(isUsed);

            if (isUsed) {
                setDeleteDescription(`${node.title} kan niet worden verwijderd omdat de volgende waarde in het systeem word gebruikt.`);
                setUsedValues(response['data']);
            } else {
                setDeleteDescription(`${node.title} kan worden verwijderd.`);
            }
        });
    }

    const [copiedId, setCopiedId] = useState<any>(false);
    useEffect(() => {
        navigator.clipboard.writeText(node.value);

        if (copiedId) {
            setTimeout(() => {
                setCopiedId(false);
            }, 400);
        }
    }, [copiedId]);

    return (
        <div>
            <div className={`expandable ${nestedKey > 0 ? `child-${nestedKey}` : ''} ${css||''} ${isExpanded?'expanded':''}`} style={{marginBottom: '1px'}}>
                <div className={`expandable-item`}>
                    { (node.children || nestedKey == 0) && <div className={'expandable-item__arrow'} onClick={() => setExpanded(!isExpanded)}>
                        <Arrow />
                    </div> }
                    <div className={'expandable-item__wrapper'}>
                        <div className={'expandable-item__name'}>
                            { !isEdit && node.title }
                            { isEdit && <Field type={FieldType.Text} isEdit={true} value={editValue} onChange={(value: any) => setEditValue(value)} /> }
                        </div>
                        <div className={'expandable-item__toolbox'}>
                            <EditButtons
                                onEdit={(value) => setEdit(value)}
                                onSave={() => editHandler()}
                                onCancel={() => setEdit(false)}
                                isDropdown
                                onDelete={deleteHandler}
                                deleteDescription={<>
                                    {deleteDescription}

                                    <ul>
                                        { usedValues.map((item: any) => <li>{item.title}</li>) }
                                    </ul>
                                </>}
                                onDeleteOpen={(a) => onDeleteOpen(a)}
                                isDeleteDisabled={isDeleteDisabled}
                            >
                                { !node.children && <DotBtnItem name={'Laag toevoegen'} onClick={() => setChildOpen(true)} /> }
                                { node.children && !isEdit && <DotBtnItem name={'Dataset kopieren'} onClick={() => setCopyModal(true)} /> }
                                <DotBtnItem name={copiedId ? 'Gekopieerd!' : 'Kopieer ID'} onClick={() => setCopiedId(true)} />
                            </EditButtons>
                        </div>
                    </div>
                </div>
            </div>

            {
                isChildOpen &&
                <Modal>
                    <ModalHeader>
                        <Title size='large' weight='bold'>Voeg laag onder <u>{node.title}</u></Title>
                    </ModalHeader>
                    <br/>
                    <Container>
                        <FormSection>
                            <FormGroup title='Label'>
                                <Field
                                    type={FieldType.Text}
                                    isEdit={true}
                                    value={addChild}
                                    onChange={(value: any) => setAddChild(value)}
                                />
                            </FormGroup>
                        </FormSection>
                    </Container>
                    <br/>
                    <ModalFooter>
                        <ButtonGroup>
                            <Button
                                variant='transparent'
                                onClick={() => setChildOpen(false)}
                            >
                                Annuleren
                            </Button>
                            <Button
                                color='primary'
                                variant='solid'
                                onClick={() => createChildHandler()}
                            >
                                Toevogen
                            </Button>
                        </ButtonGroup>
                    </ModalFooter>
                </Modal>
            }
            {
                isSibling &&
                <Modal>
                    <ModalHeader>
                        <Title size='large' weight='bold'>Waarde toevoegen</Title>
                    </ModalHeader>
                    <br/>
                    <Container>
                        <FormSection>
                            <FormGroup title='Label'>
                                <Field
                                    type={FieldType.Text}
                                    isEdit={true}
                                    value={addSibling}
                                    onChange={(value: any) => setAddSibling(value)}
                                />
                            </FormGroup>
                        </FormSection>
                    </Container>
                    <br/>
                    <ModalFooter>
                        <ButtonGroup>
                            <Button
                                variant='transparent'
                                onClick={() => setSiblingOpen(false)}
                            >
                                Annuleren
                            </Button>
                            <Button
                                color='primary'
                                variant='solid'
                                isDisabled={!addSibling}
                                onClick={() => createSiblingHandler()}
                            >
                                Toevoegen
                            </Button>
                        </ButtonGroup>
                    </ModalFooter>
                </Modal>
            }
            {
                copyModal && <Modal>
                    <ModalHeader>
                        <Title size='large' weight='bold'>Waardes onder <u>{node.title}</u> kopieren</Title>
                    </ModalHeader>
                    <br/>
                    <Container>
                        <FormSection>
                            <FormGroup title='Label'>
                                <Field
                                    type={FieldType.Text}
                                    isEdit={true}
                                    value={copyNode}
                                    onChange={(value: any) => setCopyNode(value)}
                                />
                            </FormGroup>
                        </FormSection>
                    </Container>
                    <br/>
                    <ModalFooter>
                        <ButtonGroup>
                            <Button
                                variant='transparent'
                                onClick={() => setCopyModal(false)}
                            >
                                Annuleren
                            </Button>
                            <Button
                                color='primary'
                                variant='solid'
                                isDisabled={!copyNode}
                                onClick={copyHandler}
                            >
                                Toevoegen
                            </Button>
                        </ButtonGroup>
                    </ModalFooter>
                </Modal>
            }
            
            { isExpanded && node.children && nodeKeys.map((key: any) => (
                <DatasetNode
                    nestedKey={nestedKey}
                    node={node.children[key]}
                    isLastInArray={key === nodeKeys[nodeKeys.length-1]}
                    key={node.children[key].value}
                    parentId={id}
                    id={node.children[key].value} />
            )) }

            {
                isLastInArray && <div className={`expandable ${nestedKey > 0 ? `child-${nestedKey}` : 'child-1'} last-child`} style={{marginBottom: '15px'}}>
                    <div className={`expandable-item`}>
                        <div className={'expandable-item__wrapper'}>
                            <div className={'expandable-item__name'}>
                                <Button
                                    variant='transparent'
                                    onClick={() => setSiblingOpen(true)}
                                >
                                    Item toevoegen
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

const DatasetNode = connect(
    (state: any) => ({
        datasets: getAllDatasets(state)
    }),
    {
        createDataset,
        editDataset,
        copyDataset,
        deleteDataset
    }
)(DatasetNodeContainer);


export default DatasetNode;